const movieData = {
    title: "Chiram",
    tagline: "Beyond the Horizon of Time",
    
    description: {
      english: "A Malayali girl named Seetha comes to Visva-Bharati University in Calcutta to conduct research on the topic of 'Baul Music and Life'. There, Seetha falls in love with Sam, a freelance photographer who is a friend of her professor. To learn the similarities between Baul life and tribal life, Seetha goes to a tribal area in Kerala with Sam. By chance, she has to take over the responsibility of a teacher in a single-teacher school there. Sam, who travels to the Mahananda forests of Bengal as part of his job, never returns. The wildness, charm of the forest, and her commitment to the tribal community keep her there. Years later, Chant, a tribal girl who studied with Seetha's support, returns to the forest after earning a doctorate from Visva-Bharati University. Chant informs Seeta that she has no choice but to leave the forest and go to the outside world, realizing that he must use the knowledge she has gained for the sustainable development of his community. Seeing that her mission is complete, Seeta leaves the forest and sets out in search of Sam. Realizing that life is an endless quest for achievement, Seeta reaches the level of self-discovery.",
      
      french: "Seetha, une jeune fille malayali, se rend à l'université Visva-Bharati de Calcutta pour mener des recherches sur la musique et la vie des Bauls. Là, elle tombe amoureuse de Sam, un photographe indépendant ami de son professeur. Pour comprendre les similitudes entre la vie des Bauls et celle des tribus, Seetha se rend avec Sam dans une zone tribale du Kerala. Par hasard, elle doit prendre la relève d'une enseignante dans une école à maître unique. Sam, qui se rend dans les forêts de Mahananda au Bengale pour son travail, ne revient jamais. La nature sauvage, le charme de la forêt et son engagement envers la communauté tribale la retiennent. Des années plus tard, Chant, une jeune fille tribale qui a étudié avec le soutien de Seetha, retourne dans la forêt après avoir obtenu un doctorat à l'université Visva-Bharati. Chant informe Seeta qu'elle n'a d'autre choix que de quitter la forêt et de se réfugier dans le monde extérieur, réalisant qu'il doit mettre à profit les connaissances qu'elle a acquises pour le développement durable de sa communauté. Voyant sa mission accomplie, Seeta quitte la forêt et part à la recherche de Sam. Comprenant que la vie est une quête sans fin d'accomplissement, Seeta atteint le stade de la découverte de soi.",
      
      spanish: "Una joven malaya llamada Seetha llega a la Universidad Visva-Bharati de Calcuta para investigar sobre la música y la vida de los baul. Allí, Seetha se enamora de Sam, un fotógrafo independiente amigo de su profesor. Para descubrir las similitudes entre la vida baul y la tribal, Seetha viaja a una zona tribal de Kerala con Sam. Por casualidad, debe asumir la responsabilidad de una maestra en una escuela unipersonal. Sam, quien viaja a los bosques de Mahananda en Bengala por trabajo, nunca regresa. La naturaleza salvaje, el encanto del bosque y su compromiso con la comunidad tribal la retienen allí. Años después, Chant, una joven tribal que estudió con el apoyo de Seetha, regresa al bosque tras obtener un doctorado en la Universidad Visva-Bharati. Chant le informa a Seetha que no le queda más remedio que abandonar el bosque y salir al mundo exterior, consciente de que debe utilizar los conocimientos que ella ha adquirido para el desarrollo sostenible de su comunidad. Al ver cumplida su misión, Seeta abandona el bosque y parte en busca de Sam. Al comprender que la vida es una búsqueda incesante de logros, Seeta alcanza el nivel de autodescubrimiento."
    },
    
    directors: [
      {
        name: "Sindhu Paradayil",
        role: "Director",
        image: "/images/placeholder-director1.jpg" 
      },
      {
        name: "N Sudheer",
        role: "Director",
        image: "/images/placeholder-director2.jpg",
      }
    ],
    
    producers: [
      {
        name: "Sathyajith Nair",
        role: "Producer",
        image: "/images/prod3.jpg",
      },
      {
        name: "Suresh Kumar",
        role: "Co-Producer",
        image: "/images/coprod.jpg",
      },
      {
        name: "Sajith Krishna",
        role: "Line Producer",
        image: "/images/placeholder-producer2.jpg",
      }
    ],
    
    cast: [
      {
        name: "Anoop Menon",
        character: "",
        image: "/images/placeholder-cast1.jpg"
      },
      {
        name: "Aiswarya Midhun Koroth",
        character: "",
        image: "/images/placeholder-cast2.jpg"
      },
      {
        name: "Sreekanth Murali",
        character: "",
        image: "/images/placeholder-cast3.jpg"
      },
      {
        name: "Shelly Kishore",
        character: "",
        image: "/images/placeholder-cast4.jpg"
      },
      {
        name: "Geethi Sangeetha",
        character: "",
        image: "/images/placeholder-cast5.jpg"
      },
      {
        name: "Thejaswi Bhakth",
        character: "",
        image: "/images/placeholder-cast6.jpg"
      },
    ],
    
    crew: [
      {
        role: "Screenplay and Dialogue",
        names: ["Sindhu Paradayil", "K Rajagopal"]
      },
      {
        role: "Cinematography",
        names: ["Anand Balakrishnan"]
      },
      {
        role: "Editing",
        names: ["C V Sajayyan"]
      },
      {
        role: "Music",
        names: ["M Jayachandran", "Gireesh Narayan"]
      },
      {
        role: "Lyrics",
        names: ["K Rajagopal", "B K Harinarayan", "Muralimash Mankulam"]
      },
      {
        role: "Sound Designing",
        names: ["Ranganath Ravi"]
      }
    ],
    
    productionCompany: "SATHYAJITH PRODUCTIONS",
    
    whyWatch: [
      {
        emoji: "🌿",
        title: "Inner Transformation Through Service",
        description: "Seetha's journey is not driven by ambition or ego—it's led by a genuine commitment to understanding others, be it the Bauls, tribal children, or a missing loved one. Her evolution from researcher to caregiver reflects how true growth often happens in unexpected, humble places."
      },
      {
        emoji: "🎶",
        title: "Immersion in Forgotten Worlds",
        description: "The film opens up two fading yet rich cultures—Baul mysticism and tribal life in Kerala—through a lens of respect, wonder, and lived experience. For anyone interested in music, folk traditions, or indigenous wisdom, this is a soulful exploration."
      },
      {
        emoji: "🌲",
        title: "Rooted in Nature",
        description: "The forests of Bengal and Kerala are not just settings—they are characters. Nature in this story heals, teaches, and holds memory. It offers a kind of truth that modern life often forgets."
      },
      {
        emoji: "❤",
        title: "Delicate Romance",
        description: "There's no melodrama here—Seetha and Sam's connection is felt through glances, shared silences, and a mutual hunger for freedom. It's a love story that respects space, individuality, and creative spirit."
      },
      {
        emoji: "👣",
        title: "Explores Loss Without Bitterness",
        description: "Sam's disappearance is not treated as a tragedy, but as part of life's unpredictable rhythm. The film suggests that letting go is not the end of love—it's the beginning of understanding."
      },
      {
        emoji: "🌱",
        title: "Ends With Legacy",
        description: "When Chant returns, the film quietly celebrates a cycle completed. Seetha has passed on not just knowledge, but a way of living. Her departure is not about escape—it's about moving toward the next question."
      }
    ]
  };
  
  export default movieData;